import type {
  OpenMainContentTabInput,
  Tab,
  TabNavigationState,
} from '../../store/layoutStore';
import { extractEndpointIdFromTab } from '../extractEndpointIdFromTab';

export const DELETED_SOURCE_ASSETS_TAB = {
  id: 'assets-list',
  title: 'Assets',
  type: 'assets-list',
} as const satisfies OpenMainContentTabInput;

type LeaveDeletedSourceEndpointViewInput = {
  sourceEndpointId: string;
  tabs: readonly Tab[];
  activeTabId: string | undefined;
  tabNavigationByTabId: Record<string, TabNavigationState | undefined>;
  goBackInActiveTab: () => void;
  navigateInActiveTab: (tab: OpenMainContentTabInput) => void;
  closeTab: (tabId: string) => void;
};

export const isTabShowingEndpoint = ({
  tab,
  endpointId,
}: {
  tab: Tab;
  endpointId: string;
}): boolean => {
  if (tab.type !== 'endpoint') {
    return false;
  }

  return (
    tab.id === `endpoint-${endpointId}` ||
    extractEndpointIdFromTab({ tab }) === endpointId
  );
};

export const leaveDeletedSourceEndpointView = ({
  sourceEndpointId,
  tabs,
  activeTabId,
  tabNavigationByTabId,
  goBackInActiveTab,
  navigateInActiveTab,
  closeTab,
}: LeaveDeletedSourceEndpointViewInput): void => {
  const matchingTabs = tabs.filter((tab) =>
    isTabShowingEndpoint({ tab, endpointId: sourceEndpointId }),
  );
  const activeMatching = matchingTabs.find((tab) => tab.id === activeTabId);

  if (activeMatching) {
    const navigation = tabNavigationByTabId[activeMatching.id];
    const previous = navigation?.entries[navigation.currentIndex - 1];

    if (previous?.type === 'assets-list') {
      goBackInActiveTab();
    } else {
      navigateInActiveTab(DELETED_SOURCE_ASSETS_TAB);
    }
  }

  matchingTabs
    .filter((tab) => tab.id !== activeMatching?.id)
    .forEach((tab) => {
      closeTab(tab.id);
    });
};
